/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
import { useEffect, useState } from 'react';
import useCompactMode from './useCompactMode';
import { useAuth } from '../contexts/AuthContext';

// REGLE DE GESTION V6.1.0 : mobile et tablette partagent les ecrans compacts,
// mais leurs menus peuvent etre administres separement dans les roles.
function getDeviceClass() {
  if (typeof window === 'undefined') return 'desktop';
  const width = window.innerWidth || 1440;
  if (width <= 767) return 'mobile';
  if (width <= 1366 && (width <= 1024 || window.matchMedia?.('(pointer: coarse)').matches)) return 'tablet';
  return 'desktop';
}

export default function useMobileWorkspace() {
  const compact = useCompactMode();
  const { user, hasPermission } = useAuth();
  const [deviceClass, setDeviceClass] = useState(getDeviceClass);

  useEffect(() => {
    const update = () => setDeviceClass(getDeviceClass());
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  const configured = user?.mobile_mode || 'auto';
  const roleCodes = user?.role_codes || [user?.role].filter(Boolean);
  const technicianByRole = roleCodes.some(code => ['technician', 'technicien', 'it_technician'].includes(String(code || '').toLowerCase()));
  const technicianByProfile = configured === 'interventions';
  const projectForced = configured === 'projects';
  const technicianMode = compact && !projectForced && (technicianByProfile || (configured === 'auto' && technicianByRole));
  return {
    compact,
    deviceClass,
    isMobile: deviceClass === 'mobile',
    isTablet: deviceClass === 'tablet',
    mode: technicianMode ? 'interventions' : 'projects',
    technicianMode,
    canProjects: hasPermission('projects:read'),
    canInterventions: hasPermission('interventions:read'),
    canAssets: hasPermission('assets:read'),
    canTime: hasPermission('time:read'),
  };
}
